<template>
  <div class="article-show">
    <CardWrapper :loading="!article">
      <div class="text-h6">{{ article ? article.doi : '' }}</div>
    </CardWrapper>

    <section class="section-1">
      <Section1Card1 :article="article" />
      <Section1Card2 :article="article" />
      <Section1Card3 :article="article" @update-apc="updateApc" @update-other-charges="updateOtherCharges" />
    </section>

    <Section2Card1 :article="article" />

    <CardWrapper :loading="!article" class="article-summary">
      <template v-if="article">
        <div class="title">ARTICLE SUMMARY</div>

        <div class="content">
          <div class="left">
            <Section3SubjectAreas :article="article" />
            <Section3CorrespAuthor :article="article" />
            <Section3MoreInfo :article="article" />
          </div>

          <div class="right">
            <div class="row wrap">
              <div class="col-md-6 col-sm-12">
                <Citations :article="article" />
              </div>

              <div class="col-md-6 col-sm-12">
                <div class="scite">
                  <div class="scite-badge" data-doi="10.1007/s00010-014-0332-0"></div>
                  <link rel="stylesheet" type="text/css" href="https://cdn.scite.ai/badge/scite-badge-latest.min.css" />
                  <script
                    type="application/javascript"
                    src="https://cdn.scite.ai/badge/scite-badge-latest.min.js"
                  ></script>
                </div>
              </div>
            </div>

            <Mentions :article="article" />
          </div>
        </div>
      </template>
    </CardWrapper>
  </div>
</template>

<script>
import * as apiTo from './api'
// Components
import CardWrapper from './components/CardWrapper'
import Section1Card1 from './components/section-1/Card1'
import Section1Card2 from './components/section-1/Card2'
import Section1Card3 from './components/section-1/card-3/Card3'
import Section2Card1 from './components/section-2/Card1'
import Section3SubjectAreas from './components/section-3/SubjectAreas'
import Section3CorrespAuthor from './components/section-3/CorrespAuthor'
import Section3MoreInfo from './components/section-3/MoreInfo'
import Citations from './components/section-3/Citations'
import Mentions from './components/section-3/Mentions'

export default {
  components: {
    CardWrapper,
    Section1Card1,
    Section1Card2,
    Section1Card3,
    Section2Card1,
    Section3SubjectAreas,
    Section3CorrespAuthor,
    Section3MoreInfo,
    Citations,
    Mentions
  },

  props: {
    id: [Number, String] // from route
  },

  data: () => ({
    article: null
  }),

  created() {
    apiTo.getArticle(this.id).then(
      ({ data }) =>
        (this.article = {
          ...data.result,
          apc: +data.result.apc || null,
          other_charges: +data.result.other_charges || null
        })
    )
  },

  methods: {
    updateApc(newVal, oldVal) {
      apiTo.updateArticle(this.article.id, { apc: newVal }).catch(() => (this.article.apc = oldVal))
    },

    updateOtherCharges(newVal, oldVal) {
      apiTo.updateArticle(this.article.id, { other_charges: newVal }).catch(() => (this.article.other_charges = oldVal))
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '~@/styles/stylus/custom-variables'

.article-show {
  height 100vh
  overflow auto
  padding 30px 40px
  display grid
  grid-template-rows auto 200px 120px 1fr
  gap 20px
  background-color #e6e6e6

  .section-1 {
    display grid
    grid-template-columns 200px 1fr 400px
    gap 20px
  }

  .article-summary {
    display grid
    grid-template-rows auto 1fr
    gap 10px
    margin-bottom 30px

    > .content {
      display grid
      grid-template-columns 1fr 1fr
      gap 10px

      > .left, > .right {
        display grid
        gap 10px
      }
    }
  }
}
</style>
